import React from 'react';
import toast from 'react-hot-toast';
import hotToast from 'react-hot-toast';
import { toast as reactToast } from 'react-toastify';

import {
  CopiedText,
  IconAndToastMessageWrapper,
  IconWrapper,
  ParagraphElement,
  ToasterContainer,
  ToastMessageWrapper,
  ToastWrapper
} from './styledComponents';

import './styles.css';

import { CrossIcon } from '../../icons/CrossIcon';
import { PinScaleDangerIcon } from '../../icons/PinScaleDangerIcon';
import { colors as Colors } from '../../themes/Colors';

export const customToast = (message) => {
  toast.custom((t) => (
    <ToasterContainer>
      <ToastWrapper>
        <IconAndToastMessageWrapper>
          <IconWrapper>
            <PinScaleDangerIcon />
          </IconWrapper>
          <ToastMessageWrapper>
            <ParagraphElement>{message}</ParagraphElement>
          </ToastMessageWrapper>
        </IconAndToastMessageWrapper>
      </ToastWrapper>
    </ToasterContainer>
  ));
};

export const copiedCustomToast = (message) => {
  toast.custom((t) => {
    const onClickCrossIcon = () => {
      toast.dismiss(t.id);
    };

    return (
      <div
        className={`${
          t.visible ? 'animate-enter' : 'animate-leave'
        } copied-custom-toast-main-container`}
      >
        <div className="copied-custom-toast-container">
          <div className="flex items-center justify-between">
            <div className="copied-custom-toast-text-container">
              <p className="copied-custom-toast-message">{message}</p>
            </div>
            <button
              className="copied-custom-toast-button"
              onClick={onClickCrossIcon}
            >
              <CrossIcon />
            </button>
          </div>
        </div>
      </div>
    );
  });
};

export const copiedCustomToastDesktop = (message) => {
  toast.custom((t) => (
    <div className={`${t.visible ? 'animate-enter' : 'animate-leave'}`}>
      <CopiedText>{message}</CopiedText>
    </div>
  ));
};

export const showErrorToast = (
  errorMessage,
  options = {},
  customComponent?: any,
  customStyles = {}
) => {
  if (customComponent) {
    const CustomComponent = customComponent;
    hotToast.custom((t) => <CustomComponent message={errorMessage} t={t} />);
    return null;
  }

  return reactToast.error(({ closeToast }) => errorMessage, {
    autoClose: 2000,
    position: reactToast.POSITION.BOTTOM_CENTER,
    closeButton: false,
    style: {
      border: `1px solid ${Colors.lipstick}`,
      background: `${Colors.mistyRose}`,
      padding: '2px 16px',
      fontSize: '16px',
      fontFamily: 'HkGrotesk',
      fontWeight: 500,
      color: Colors.lipstick,
      borderRadius: '4px',
      width: '328px',
      height: '40px',
      minHeight: '40px',
      margin: 'auto',
      marginBottom: '48px',
      ...customStyles
    },
    ...options
  });
};
export const showSuccessToast = (successMessage) => {
  return reactToast.success(({ closeToast }) => successMessage, {
    autoClose: 2000,
    position: reactToast.POSITION.BOTTOM_CENTER
  });
};
